/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Legacy_Search_GroupInputs */

const vi_carrier_legacy_search_group = /** @type {(inputs: Carrier_Legacy_Search_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xã cũ khác trong tỉnh`)
};

/**

* @param {Carrier_Legacy_Search_GroupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_legacy_search_group = /** @type {((inputs?: Carrier_Legacy_Search_GroupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Legacy_Search_GroupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_legacy_search_group(inputs)
});